{
  "apiKey": "AIzaSyD8MgmpxvXgItD0FUBnvl5HH-LHn6uvy6Q",
  "authDomain": "nrg-app-ba395.firebaseapp.com",
  "databaseURL": "https://nrg-app-ba395.firebaseio.com",
  "projectId": "nrg-app-ba395",
  "storageBucket": "nrg-app-ba395.firebasestorage.app",
  "messagingSenderId": "1000558699693",
  "appId": "1:1000558699693:web:7e60979611299e9ac61224",
  "measurementId": "G-KW3PFQJ1XQ"
}
